import React, { Component } from 'react';
import '../assets/css/bootstrap.min.css';
import '../assets/css/style.css';
import { Link } from 'react-router-dom';
import Tabs from "../Components/Tabs";
import profilePic from '../assets/images/user-profile/profile-picture.png';
import instaIcon from '../assets/images/account-info/instagram.png';
import facebookIcon from '../assets/images/account-info/facebook.png';
import collection1 from '../assets/images/user-profile/collection-1.png';
import collection2 from '../assets/images/user-profile/collection-2.png';
import card1 from '../assets/images/user-profile/artwork-card-1.png';
import card2 from '../assets/images/user-profile/artwork-card-2.png';
import Header from './Header';

class UserProfileArtist extends Component {
    Collection = () => {
        this.props.history.push('/Collection');
    }
    render() {
        return (
            <div className="main-wrapper">
                {/* Header area start */}
                <Header />
                {/* Header area end */}

                {/* User Profile Artist area start */}
                <div className="container">
                    <div className="row justify-content-center user-area">
                        <div className="text-center">
                            <img src={profilePic} alt="" />
                            <h1>Artist Name</h1>
                            <small>@artisthandle</small>
                            <div>
                                <Link to="#"><img className="social-icon" src={instaIcon} alt="Instagram" /></Link>
                                <Link to="#"><img className="social-icon" src={facebookIcon} alt="Facebook" /></Link>
                            </div>
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p>
                        </div>
                    </div>
                </div>
                {/* User Profile Artist area end */}


                {/* Tabs area start */}
                <div className="container mb-5">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 text-center p-3">
                            <Tabs>
                                <div className="created-tab" label="Created">
                                    <p className="created-content">2 Collections created and dropped by @artisthandle on Lorem.</p>
                                    <div className="row artist-created-content justify-content-between">
                                        <h6>Collection Title by Artist Name</h6>
                                        <h6>1:08PM EST – March 25, 2021</h6>
                                        <img className="artist-collection-img" src={collection1} onClick={this.Collection} alt="collection1" />
                                        <h6>Collection Title by Artist Name</h6>
                                        <h6>3:14PM EST – March 14, 2021</h6>
                                        <img className="artist-collection-img" src={collection2} onClick={this.Collection} alt="collection2" />
                                    </div>
                                </div>
                                <div className="curated-tab" label="Curated">
                                    <p className="created-content">2 NFTS owned by @artisthandle on Lorem.</p>
                                    <div className="row justify-content-center user-card">
                                        <div className="card text-left mt-4">
                                            <Link to="/SpecificItem">
                                                <img src={card1} className="card-img-top" alt="" />
                                            </Link>
                                            <div className="card-body">
                                                <Link to="/SpecificItem">
                                                    <h3>Artwork Title</h3>
                                                </Link>
                                                <span><strong>$ 60,000.00</strong>&emsp;<small>6 OF 26</small></span>
                                                <p className="card-text"><span><small>HIGHEST BID</small>&emsp;<strong>$49,000.00</strong></span></p>
                                            </div>
                                        </div>
                                        <div className="card text-left mt-4">
                                            <Link to="/SpecificItem">
                                                <img src={card2} className="card-img-top" alt="" />
                                            </Link>
                                            <div className="card-body">
                                                <Link to="/SpecificItem">
                                                    <h3>Artwork Title</h3>
                                                </Link>
                                                <span><strong>Not for sale</strong>&emsp;<small>7 OF 26</small></span>
                                                <p className="card-text"><span><small>LAST SOLD</small>&emsp;<strong>$13,000.00</strong></span></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Tabs>
                        </div>
                    </div>
                </div>
                {/* Tabs area end */}
            </div>
        )
    }
};

export default UserProfileArtist;